module.exports = __webpack_public_path__ + "static/media/GddTool-thumbnail.8e0a8228.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ToolCard/thumbnails/GddTool-thumbnail.png
// module id = 1216
// module chunks = 0